import { getApiErrorMessage } from '../ApiErrorMessages';
export type ApiErrorObj = {
  code: string;
  message: string;
  detail: string;
  type:
    | 'InternalServerError'
    | 'InvalidError'
    | 'UnauthorizedError'
    | 'PermissionError'
    | 'NotFoundError';
  requestId: string;
};
export class ApiError extends Error {
  code: string;
  detail: string;
  type:
    | 'InternalServerError'
    | 'InvalidError'
    | 'UnauthorizedError'
    | 'PermissionError'
    | 'NotFoundError';
  requestId: string;
  constructor(e: ApiErrorObj) {
    super(getApiErrorMessage(e.code));
    this.name = new.target.name;
    this.code = e.code;
    this.type = e.type;
    this.detail = e.detail;
    this.requestId = e.requestId;
  }
}
